import { Calculator, ArrowLeft } from "lucide-react";
import MemberLayout from "@/components/app/MemberLayout";

// Static list of calculators for MVP — will be replaced with a dynamic Campaign-driven list later.
const CALCULATORS = [
  { key: "eligibility", title: "בדיקת זכאות לאיחוד הלוואות", desc: "בדיקה מהירה של האפשרויות הכי טובות עבורכם.", url: "/funnel/1" },
  { key: "mortgage", title: "מחשבון החזרים למשכנתה", desc: "כמה תשלמו בכל חודש, ומה סך הריבית לאורך התקופה.", url: "/funnel/2" },
  { key: "mapping",  title: "מחשבון מיפוי חובות", desc: "מפו את כל החובות שלכם וראו את התמונה המלאה.", url: "/funnel/3" },
];

export default function Calculators() {
  return (
    <MemberLayout>
      <div className="px-4 sm:px-8 lg:px-12 py-8" data-testid="calculators-page">
        <div className="mb-8">
          <div className="text-xs font-bold text-amber-500 tracking-widest uppercase mb-2">כלים</div>
          <h1 className="font-[Rubik] font-black text-3xl sm:text-4xl text-stone-50 mb-2">המחשבונים שלי</h1>
          <p className="text-stone-400">בחרו את הכלי שהכי מתאים למצב שלכם עכשיו.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CALCULATORS.map((c) => (
            <a
              key={c.key}
              href={c.url}
              className="group bg-stone-900 border border-stone-800 hover:border-amber-600/50 rounded-2xl p-6 transition-all hover:-translate-y-1"
              data-testid={`calc-${c.key}`}
            >
              <div className="w-12 h-12 rounded-xl bg-amber-600/15 border border-amber-600/30 flex items-center justify-center mb-4">
                <Calculator className="w-6 h-6 text-amber-500" />
              </div>
              <h3 className="font-[Rubik] font-bold text-lg text-stone-100 mb-2">{c.title}</h3>
              <p className="text-sm text-stone-400 leading-relaxed mb-4">{c.desc}</p>
              <div className="inline-flex items-center gap-1 text-sm font-bold text-amber-500 group-hover:gap-2 transition-all">
                <ArrowLeft className="w-4 h-4 -scale-x-100" />
                למחשבון
              </div>
            </a>
          ))}
        </div>
      </div>
    </MemberLayout>
  );
}
